export default "__VITE_ASSET__BuGUWXFc__";